import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CadastrarInsumoRecord from '@components/InsumoRecord/CadastrarInsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';
import { withRouter } from 'react-router-dom';

/**
 * Tela para cadastro de inseticida microbiologico
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function EditarInseticidaMicrobiologico(props) {
  useEffect(() => {
    const title = 'inseticidaMicroBio.cadastroDeInseticidaMicroBio';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <CadastrarInsumoRecord
      id={props.match.params.id}
      insumoURL={'inseticidas-microbiologicos'}
      insumoEnum={Insumo.INSETICIDA_MICROBIOLOGICO}
      infoUsuario={props.infoUsuario}
      saveMessage={formatMessage(
        'inseticidaMicroBio.' +
          (props.match.params.id
            ? 'inseticidaMicroBioEditadoComSucesso'
            : 'inseticidaMicroBioCadastradoComSucesso')
      )}
      falhaSaveMesssage={formatMessage(
        'inseticidaMicroBio.' +
          (props.match.params.id
            ? 'falhaAoEditarInseticidaMicroBio'
            : 'falhaAoCadastrarInseticidaMicroBio')
      )}
      falhaCarregarMensagem={formatMessage('inseticidaMicroBio.falhaAoCarregarInseticidaMicroBio')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

export default withRouter(connect(mapStateToProps)(EditarInseticidaMicrobiologico));
